export const DROP_LINE_GAP_OFFSET = 6;
const DRAG_SCROLL_EDGE_THRESHOLD = 100;
const DRAG_SCROLL_STEP = 18;

export const areSectionOrdersEqual = (left = [], right = []) => {
  if (left.length !== right.length) {
    return false;
  }

  for (let index = 0; index < left.length; index += 1) {
    if (left[index] !== right[index]) {
      return false;
    }
  }

  return true;
};

const getScrollableAncestor = (element) => {
  let current = element ? element.parentElement : null;

  while (current) {
    const style = window.getComputedStyle(current);
    const overflowY = style ? style.overflowY : "visible";
    const isScrollable = overflowY === "auto" || overflowY === "scroll";

    if (isScrollable && current.scrollHeight > current.clientHeight) {
      return current;
    }

    current = current.parentElement;
  }

  return null;
};

export const autoScrollForDrag = (event) => {
  const scrollParent = getScrollableAncestor(event.currentTarget);

  if (scrollParent) {
    const bounds = scrollParent.getBoundingClientRect();

    if (event.clientY > bounds.bottom - DRAG_SCROLL_EDGE_THRESHOLD) {
      scrollParent.scrollTop += DRAG_SCROLL_STEP;
      return;
    }

    if (event.clientY < bounds.top + DRAG_SCROLL_EDGE_THRESHOLD) {
      scrollParent.scrollTop -= DRAG_SCROLL_STEP;
      return;
    }
  }

  if (event.clientY > window.innerHeight - DRAG_SCROLL_EDGE_THRESHOLD) {
    window.scrollBy(0, DRAG_SCROLL_STEP);
    return;
  }

  if (event.clientY < DRAG_SCROLL_EDGE_THRESHOLD) {
    window.scrollBy(0, -DRAG_SCROLL_STEP);
  }
};